export const API_ENABLED = process.env.API_ENABLED || false;
export const API_URL = process.env.API_URL || "http://localhost";
export const API_PORT = process.env.API_PORT || 3000;
